export default {
  remote: 'multi-language-translation',
  name: 'multi-language-translation',
  source: 'https://github.com/telus/multi-language-translation',
  urlMapping: {
    'localhost': 'http://localhost:4321/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1285386228/multi-language-translation/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1285386228/multi-language-translation/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1285386228/multi-language-translation/v1/mf2/mf-manifest.json',
  }
};
